const getState = (state: AppState) => state.program;

export const programSelector = {
  getState,
};
